var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1379 0C12.285 0 14.1136 1.35586 14.7865 3.25H16.7126C18.5258 3.25 20 4.70742 20 6.5V22.75C20 24.5426 18.5258 26 16.7126 26H3.56322C1.75004 26 0.275862 24.5426 0.275862 22.75V6.5C0.275862 4.70742 1.75004 3.25 3.56322 3.25H5.4894C6.16228 1.35586 7.99088 0 10.1379 0ZM10.1379 6.5C11.0471 6.5 11.7816 5.77383 11.7816 4.875C11.7816 3.97617 11.0471 3.25 10.1379 3.25C9.22877 3.25 8.49425 3.97617 8.49425 4.875C8.49425 5.77383 9.22877 6.5 10.1379 6.5ZM6.85057 13C6.85057 14.7926 8.32475 16.25 10.1379 16.25C11.9511 16.25 13.4253 14.7926 13.4253 13C13.4253 11.2074 11.9511 9.75 10.1379 9.75C8.32475 9.75 6.85057 11.2074 6.85057 13ZM15.8908 21.9375C15.8908 19.693 14.0519 17.875 11.7816 17.875H8.49425C6.22392 17.875 4.38506 19.693 4.38506 21.9375C4.38506 22.3844 4.75488 22.75 5.2069 22.75H15.069C15.521 22.75 15.8908 22.3844 15.8908 21.9375Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.1bd1ab5ef9efa91e680f4528f8782971.svg";
export { ForwardRef as ReactComponent };